/**
 * Elite-only member dashboard (mirrors `/elite-prime-dashboard` with Elite locked).
 *
 * Belongs here: Elite-locked Active Elite dashboard with no plan switcher.
 * Does not belong here: dual-tab member (`/elite-plans-member`) or Elite sell.
 */
import '../elitePlansTheme.css'
import { ELITE_PLANS_ELITE_TAB_ID, ElitePlansLandingProvider } from '../ElitePlansLandingContext'
import { ElitePlansAnalyticsScreen } from '../constants/analyticsEvents'
import { ELITE_DASHBOARD_STATUS_QUERY_KEY } from '../constants/queryKeys'
import { ElitePlansPageShell } from '../components/ElitePlansPageShell'
import { ElitePrimeDashboardHeader } from '../components/ElitePrimeDashboardHeader'
import { ElitePlansEliteMemberDashboard } from '../components/ElitePlansEliteMemberDashboard'
import { NewEliteLandingAnalyticsScreen } from '../../new-elite-landing/analytics/newEliteLandingAnalytics'

export default function ElitePlansEliteDashboardPage() {
  return (
    <ElitePlansLandingProvider
      analyticsScreen={ElitePlansAnalyticsScreen.EliteDashboard}
      lockedPlanId={ELITE_PLANS_ELITE_TAB_ID}
      statusQueryKeyRoot={ELITE_DASHBOARD_STATUS_QUERY_KEY}
    >
      <ElitePlansEliteDashboardPageContent />
    </ElitePlansLandingProvider>
  )
}

function ElitePlansEliteDashboardPageContent() {
  // ScreenLoaded fires from ElitePlansEliteMemberDashboard when advisory status is ready
  return (
    <ElitePlansPageShell>
      <ElitePrimeDashboardHeader accent='elite' showPlanTab={false} />
      <ElitePlansEliteMemberDashboard
        statusQueryKeyRoot={ELITE_DASHBOARD_STATUS_QUERY_KEY}
        analyticsScreen={NewEliteLandingAnalyticsScreen.Dashboard}
      />
    </ElitePlansPageShell>
  )
}
